import { render } from "./AddressFile.vue?vue&type=template&id=0ee628e7"
import script from "./AddressFile.vue?vue&type=script&lang=ts"
export * from "./AddressFile.vue?vue&type=script&lang=ts"

import "./AddressFile.vue?vue&type=style&index=0&id=0ee628e7&lang=scss"
script.render = render

export default script